import React from "react";

export function Footer() {
    return (
        <footer>
            <p className="copyright">Copyright (c) KYUSHU ELECTRIC POWER CO., INC. All Rights Reserved.</p>
        </footer>
    );
}